// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import mediator from './mediator';
import router from './router';
import store from './store';
import config from './config';



new Vue({
	el: '#app',
	router,
	store,
	components: {App},
	template: '<App/>',
	async mounted () {
		await mediator.boot.initApp();
	}
});



// WEBPACK FOOTER //
// ./src/main.js